import React from 'react';
import ChartistGraph from 'react-chartist';
import Card from './Card';
import api from '../../../api';
import '../../../assets/css/utils.css';

var capitalize = function(str) {
  return str.replace(/(?:^|\s)\S/g, function(a) {
    return a.toUpperCase();
  });
};

class EstadisticasFormula extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      total: 0,
      por_articulo: 0,
      por_secciones: [],
      por_dominios: [],
      dataPie: {
        labels: [],
        series: []
      },
      legendPie: {
        names: [],
        types: []
      }
    };
  }

  crearDataPie(total, por_secciones) {
    var dataPie = { labels: [], series: [] };

    for (var i = 0; i < por_secciones.length; i++) {
      var porcentaje = por_secciones[i].percentage.toFixed(0);
      dataPie.series.push(porcentaje);
      dataPie.labels.push(' ' + porcentaje + '%');
    }
    return dataPie;
  }

  crearLegendPie(por_secciones) {
    var types = ['info', 'danger', 'warning', 'primary', 'success'];
    var legendPie = { names: [], types: [] };

    for (var i = 0; i < por_secciones.length; i++) {
      var name = por_secciones[i].seccion;
      if (name.indexOf('/') !== -1) {
        name = name.substring(name.lastIndexOf('/') + 1);
      }
      name = this.capitalize(name);
      legendPie.names.push(name);
      legendPie.types.push(types[i % types.length]);
    }
    return legendPie;
  }

  componentWillReceiveProps(nextProps) {
    // var tokens = this.props.texto.split(" ");
    var tokens = nextProps.texto.split(" ");
    var corpus = nextProps.tipoCorpus;
    var querystring = [];
    querystring.push("corpus=" + corpus);
    for (var i = 0; i < tokens.length; i++)
      querystring.push('token=' + tokens[i]);
    querystring = querystring.join('&');

    api.statistics
      .getStatistics(querystring)
      .then(response => {
        return this.setState({
          total: response.data.total,
          por_articulo: response.data.por_articulo.toFixed(3),
          por_secciones: response.data.por_secciones,
          por_dominios: response.data.por_dominios,
          dataPie: this.crearDataPie(
            response.data.total,
            response.data.por_secciones
          ),
          legendPie: this.crearLegendPie(response.data.por_secciones)
        });
      })
      .catch(error => console.log(error));
  }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json['names'].length; i++) {
      var type = 'fa fa-circle text-' + json['types'][i];
      legend.push(<i className={type} key={i}></i>);
      legend.push(' ');
      legend.push(json['names'][i]);
    }
    return legend;
  }

  crearInformacionDominio(dominios) {
    let informacion = [];

    for (var i = 0; i < dominios.length; i++) {
      informacion.push(
        <span key={i}>
          <strong> {dominios[i].dominio}: </strong>
          {dominios[i].count} apariciones ({dominios[i].percentage.toFixed(2)}%)
          {i < dominios.length - 1 ? ' | ' : ''}
        </span>
      );
    }

    return informacion;
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    var data = { labels: [], series: [] };
    var high = 0;
    this.state.por_secciones.forEach(function(seccion_data) {
      data.labels.push(capitalize(seccion_data.seccion));
      var count = parseInt(seccion_data.per_million);
      data.series.push(count);
      if (count > high) high = count;
    });
    // series should always be an array of arrays
    data.series = [data.series];

    var options = {
      high: high,
      low: 0
    };

    var type = 'Bar';
    //var chartClass = 'chart-estadisticas';

    return (
      <div>
        {this.state.total === 0 ? (
          <p>No existen datos cuantitativos</p>
        ) : (
          <Card
            id="chartPreferences"
            classes="ct-chart ct-perfect-fourth chart-estadisticas"
            category={
              <p>{this.crearInformacionDominio(this.state.por_dominios)}</p>
            }
            stats={
              <p>
                <strong>Total:</strong> {this.state.total} apariciones en el
                corpus y {this.state.por_articulo} por artículo
              </p>
            }
            content={
              <div>
                <span className="stats">
                  <strong>Número de apariciones por millón de palabras</strong>
                </span>
                <ChartistGraph data={data} options={options} type={type} />
              </div>
            }
          />
        )}
      </div>
    );
  }
}

export default EstadisticasFormula;
